import Utils from '../utils';
import SelectionManager from '../selections';
import Panel from '../panels';
import Remote from '../remote';
import flash from '../flash';
import Comments from '../../comments/comments';
import '../../../libs/vendor/immersive-reader-sdk.1.2.0.js';
import Vue from 'vue';
import ImmersiveReaderContentBuilder from '../immersiveReader.js';

export default class ContentManager {
  get dirty() {
    console.warn('ContentManager#dirty must be overriden by subclasses providing dirty tracking.');
    return false;
  }

  set dirty(value) {
    console.warn(
      'ContentManager#dirty does not provide a meaningful implementation. Subclasses must implement dirty tracking locally.',
    );
  }

  constructor(context, remote, options) {
    this.context = context;
    this.remote = remote;
    this.options = options;

    let title = '';
    if (!this.context.type && typeof this.context.id !== 'string') {
      const header = document.body.querySelector('#headerWrapper h1');
      title = header ? header.textContent : '';
    } else if (this.context?.getName) {
      title = this.context.getName();
    }
    this.immersiveReader = new ImmersiveReaderContentBuilder(title);
  }

  display(container) {
    console.error('ContentViewer#display must be overriden by a subclass.');
  }

  setupModal(panel) {
    this.setupLightbox(panel);
    return panel;
  }

  parseResult() {
    throw new Error('Subclass of ContentManager is missing an implementation of #parseResult');
  }

  setupLightbox(modal) {
    modal.content
      .find(
        '.pr2--circlePanelDescription img, .pr2--hubPanelDescription img, .pr2--nodePanelBody img, .lp--activityEditorSection.student .lp--activityEditorSectionHeader .editor-header-row img',
      )
      .on(Utils.interactionEvent, function (ev) {
        let img = ev.target;

        if ($(img).closest('a').length) {
          return;
        }

        let clone = img.cloneNode();
        let imgContainer = document.createElement('div');
        imgContainer.classList.add('lp--lightBoxImageContainer');
        imgContainer.style.backgroundImage = `url(${img.src})`;

        let container = document.createElement('div');

        let close = document.createElement('a');
        close.classList.add('lp--lightBoxImageClose');
        container.appendChild(close);

        container.appendChild(imgContainer);
        let position = img.getBoundingClientRect();

        container.classList.add('lp--lightBoxImage');

        imgContainer.style.top = position.y + 'px';
        imgContainer.style.left = position.x + 'px';
        imgContainer.style.width = position.width + 'px';
        imgContainer.style.height = position.height + 'px';

        container.style.zIndex = 1000;
        img.classList.add('lp--js-imageDisplayedInLightbox');
        document.body.appendChild(container);

        setTimeout(function () {
          imgContainer.style.left = '5vw';
          imgContainer.style.top = '5vh';
          imgContainer.style.width = '90vw';
          imgContainer.style.height = '90vh';

          if (
            img.naturalWidth < document.documentElement.clientWidth * 0.9 &&
            img.naturalHeight < document.documentElement.clientHeight * 0.9
          ) {
            imgContainer.style.backgroundSize = `${img.naturalWidth}px ${img.naturalHeight}px`;
          }
          container.classList.add('lp--lightBoxImageOpen');
        }, 10);

        $(container).on(Utils.interactionEvent, function () {
          imgContainer.style.top = position.y + 'px';
          imgContainer.style.left = position.x + 'px';
          imgContainer.style.width = position.width + 'px';
          imgContainer.style.height = position.height + 'px';
          container.classList.remove('lp--lightBoxImageOpen');
          let that = $(this);
          that.on(transition_event_name, function () {
            img.classList.remove('lp--js-imageDisplayedInLightbox');
            that.remove();
          });
        });
      });
  }

  deadline_attach() {
    this.deadline_input = this.panel.content.find('.deadline');
    this.deadline_element = this.panel.content.find('.deadline-rep');

    if (this.deadline_input) {
      this.deadline_input.datepicker({
        defaultDate: this.deadline_get(),
        dateFormat: 'yy-mm-dd',
        constrainInput: true,
        onSelect: (date, datepicker) => {
          this.deadline_element.text(date);
        },
      });
      this.deadline_element.on('keypress ' + Utils.tapInteractionEvent + '.deadline', (ev) => {
        this.deadline_input.datepicker('show');
      });
    }
  }

  updateProgress(result) {
    const { initiated_progress, done_progress, completed_progress } = result;
    $(window).trigger('progress.update', {
      initiated_progress,
      done_progress,
      completed_progress,
    });
  }

  setSaveStatus(saveStatus) {
    $('.activity-editor__status').html(i18n.__(saveStatus));
  }

  showErrorMessage(err) {
    $('.activity-editor__button-panel').addClass('error');
    this.setSaveStatus('behavior_save_failed');
    if (err.code === 413) {
      flash(i18n.__('error_payload_too_large'), { ttl: 20000 });
    } else {
      flash(i18n.__('error_behavior_save_failed'));
    }
  }

  deadline_detach() {
    if (this.deadline_input) {
      this.deadline_input.removeClass('hasDatepicker');
      this.deadline_input.datepicker('destroy');
    }
    this.panel.content.off('.deadline');
  }

  deadline_get() {
    if (this.deadline_element) {
      return isNaN(Date.parse(this.deadline_element.text())) == false ? this.deadline_element.text() : undefined;
    }
    return undefined;
  }

  deadline_save(data) {
    if (this.deadline_input) {
      return this.remote
        .put(
          this.context.getId() + '/session/' + this.options.session_id,
          $.extend({ deadline_at: this.deadline_get() }, data),
        )
        .on('noAccess', () => {
          window.location.replace('/learn/' + this.options.session_id);
        })
        .then((behavior_session) => {
          return behavior_session;
        });
    } else {
      return Promise.resolve(false);
    }
  }

  state_switcher(content, selector, tpl, callback) {
    let el = content.find(selector);
    el.on('keypress ' + Utils.tapInteractionEvent + '.state-switcher', (ev) => {
      let el = $(ev.currentTarget).parent();
      if (el.find('.state-switcher').length > 0 && this._state_switcher_tpl == tpl) {
        this.state_switcher_detach();
        return;
      }
      if (this._state_switcher) {
        this.state_switcher_detach();
      }

      this._state_switcher_tpl = tpl;

      el.append($('<div class="state-switcher">' + tpl + '</div>'));
      this._state_switcher = el.find('.state-switcher');

      this._state_switcher
        .find('[data-state]')
        .one('keypress ' + Utils.tapInteractionEvent + '.state-switcher', (ev) => {
          callback($(ev.currentTarget).attr('data-state'), $(ev.currentTarget));
          this.state_switcher_detach();
        });
    });
  }

  state_switcher_detach() {
    if (this._state_switcher) {
      this._state_switcher.off('.state-switcher');
      this._state_switcher.remove();
    }
  }

  showLoopDescription() {
    this.panel.content.find('.circle-panel-description').removeClass('collapse');
    this.panel.content.find('.collapsed-description-panel').addClass('collapse');
  }

  hideLoopDescription() {
    this.panel.content.find('.circle-panel-description').addClass('collapse');
    this.panel.content.find('.collapsed-description-panel').removeClass('collapse');
  }

  showTeacherPanelContent(show) {
    if (show) {
      $('.content-viewer').addClass('show');
      $('.toggle-content').text(i18n.__('hide_assignment'));
    } else {
      $('.content-viewer').removeClass('show');
      $('.toggle-content').text(i18n.__('show_assignment'));
    }
  }

  attach(hideDescription) {
    let that = this;
    let stateSwitch = this.panel.content.find('.lp--js-stateSwitchHook');
    const userId = document.body.getAttribute('data-user-uuid');
    const userSessionHideLoopDescriptionKey = `${userId}_${this.options.session_id}_hideLoopDescription`;
    if (hideDescription || window.localStorage.getItem(userSessionHideLoopDescriptionKey) === 'true') {
      this.hideLoopDescription();
    } else {
      this.showLoopDescription();
    }
    const userShowTeacherPanelContentKey = `${userId}_showTeacherPanelContent`;
    if (window.localStorage.getItem(userShowTeacherPanelContentKey) === 'true') {
      this.showTeacherPanelContent(true);
    }

    if (stateSwitch.length > 0) {
      let stateTool = new Vue({
        el: stateSwitch.get(0),
        template: `
        <editor-state-selector @stateChanged="stateChanged" :locked="locked" :options="options" :state="state" :isTeacher="isTeacher" :allowStates="allowStates" :allowLock="allowLock" />
        `,
        methods: {
          stateChanged: function (state, locked) {
            this.state = state;
            this.locked = locked;
            const isDraft = this.state !== 'done' && this.state !== 'accept';
            that.remote
              .put(that.context.getId() + '/session/' + that.options.session_id + '/state', {
                report_uuid: this.uuid,
                state: this.state,
                locked: this.locked,
                isDraft,
              })
              .then((res) => {
                flash(i18n.__('flash_state_changed'), { ttl: 3000, type: 'status' });
              });
          },
        },
        mounted: function () {
          $(window)
            .off('progress.updated.state_switch')
            .on('progress.updated.state_switch', (ev, data) => {
              if (that.context.id == data.node) {
                this.state = data.state;
              }
            });
        },
        data: function () {
          return {
            state: stateSwitch.attr('data-state'),
            locked: stateSwitch.attr('data-locked') == 'true',
            uuid: stateSwitch.attr('data-uuid'),
            allowStates: !stateSwitch[0].hasAttribute('data-no-state'),
            isTeacher: true,
            options: {
              help: that.options.help,
              inert: stateSwitch[0].hasAttribute('data-inert'),
            },
            allowLock: true,
          };
        },
      });
    }

    this.panel.content.find('.lp--js-teacherPanelLink[data-uuid]').on(Utils.interactionEvent, (ev) => {
      // Teacher is clicking on the teacher panel icon for an activity.
      ev.preventDefault();
      if (window.location.href.match(/teacher_panel/)) {
        window.location.href = '/learn/' + this.options.session_id + '#' + this.context.id;
      } else {
        window.location.href = '/learn/' + this.options.session_id + '/teacher_panel#' + this.context.id + '/';
      }
    });

    const toggleFullScreen = () => {
      Panel.currentPanel.content.toggleClass('lp--fullScreenPanel');
      const inFullscreen = Panel.currentPanel.content.hasClass('lp--fullScreenPanel');
      this.options.viewer.inFullscreen = inFullscreen;
      $(document).trigger('panel.fullscreen', { fullscreen: inFullscreen });
    };

    $(document).on('toggleFullScreen', () => {
      toggleFullScreen();
    });

    $('.toggle-content').on(Utils.interactionEvent, () => {
      if (window.localStorage.getItem(userShowTeacherPanelContentKey) === 'true') {
        window.localStorage.setItem(userShowTeacherPanelContentKey, false);
        this.showTeacherPanelContent(false);
      } else {
        window.localStorage.setItem(userShowTeacherPanelContentKey, true);
        this.showTeacherPanelContent(true);
      }
    });

    this.panel.content.find('.lp--js-fullScreen').off('keypress ' + Utils.tapInteractionEvent + '.fs');
    this.panel.content.find('.lp--js-fullScreen').on('keypress ' + Utils.tapInteractionEvent + '.fs', (ev) => {
      ev.target.blur();
      toggleFullScreen();
    });

    this.panel.content.find('.pr2--js-closeBtn').on('keypress ' + Utils.tapInteractionEvent + '.fs', (ev) => {
      this.panel.content.removeClass('lp--fullScreenPanel');
      this.options.viewer.inFullscreen = false;
      $(document).trigger('panel.fullscreen', { fullscreen: false });
    });

    this.panel.content.find('.lp--js-close-panel').on('keypress ' + Utils.tapInteractionEvent + '.fs', (ev) => {
      this.hideLoopDescription();
      window.localStorage.setItem(userSessionHideLoopDescriptionKey, true);
    });

    this.panel.content.find('.panel-navigation.hub').on('keypress', function () {
      $(this).trigger('click');
    });

    this.panel.content
      .find('.collapsed-description-panel')
      .on('keypress ' + Utils.tapInteractionEvent + '.fs', (ev) => {
        this.showLoopDescription();
        window.localStorage.setItem(userSessionHideLoopDescriptionKey, false);
      });

    $(document).on('comment.open', () => {
      this.panel.content.removeClass('lp--fullScreenPanel');
      this.options.viewer.inFullscreen = false;
      $(document).trigger('panel.fullscreen', {
        fullscreen: this.panel.content.hasClass('lp--fullScreenPanel'),
      });
    });

    this.panel.content.find('.lp--js-immersiveReader').on(Utils.tapInteractionEvent + '.immersiveReader', () => {
      openImmersiveReader();
    });

    this.panel.content.find('.ql-formula').attr('aria-label', i18n.__('ariaLabels.formula'));
    this.panel.content.find('.ql-formula').children().attr('aria-hidden', 'true');

    document.addEventListener('open.immersiveReader', (ev) => {
      const text = ev && ev.detail;
      openImmersiveReader({
        title: i18n.__('app_selection'),
        chunks: [{ content: text, mimeType: 'text/html' }],
      });
    });

    const immersiveReaderRemote = new Remote('/integrations/microsoft/fetchImmersiveReaderLaunchParameters');
    const fetchImmersiveReaderLaunchParameters = () => {
      return new Promise((resolve) => {
        immersiveReaderRemote.get('').then((response) => {
          return resolve(response);
        });
      });
    };

    const openImmersiveReader = async (selectedContent = undefined) => {
      const content = selectedContent || this.immersiveReader.getContent();

      let options = {};
      try {
        const [language] = (document.body.dataset.userLocale || document.body.dataset.userBaseLocale || '').split('-');
        if (language) {
          options.uiLang = language;
        }
      } catch (error) {}

      const params = await fetchImmersiveReaderLaunchParameters();
      const { token, subdomain } = params;
      ImmersiveReader.launchAsync(token, subdomain, content, options);
    };

    if (this.options.viewer.supportsCommunication()) {
      window.selectionManager = new SelectionManager();
      window.selectionManager.init({
        viewer: this.options.viewer,
        commentInstance: this.options.viewer.comments,
      });
    }

    this.panel.hideMountPoint(function (e) {
      e.preventDefault();
      if (that.options && that.options.viewer) {
        that.options.viewer
          .verifyDirtyEditContext()
          .then(() => {
            Panel.hide(that.panel);
          })
          .catch(Utils.noop);
      } else {
        Panel.hide(that.panel);
      }
    });
  }

  detach() {
    if (window.selectionManager) {
      window.selectionManager.detach();
    }
    $(window).off('.vo');
    this.panel.content.off('keypress ' + Utils.tapInteractionEvent + '.lock', '.lp--js-reportLockSwitch');
  }

  openComsContextFor(entity, uuid) {
    $(document).trigger(Comments.EventTriggerName, {
      entity_uuid: uuid,
      entity_type: entity,
    });
  }

  static viewerForContent(type) {
    if (ContentManager.Implementations[type]) {
      return ContentManager.Implementations[type];
    } else {
      return ContentManager.Implementations['default'];
    }
  }

  markAcceptedNode(uuid, state) {
    if (window.viewer) {
      const panelNode = $(`.activity-item[data-uuid=${uuid}]`);
      if (state === 'accepted' && !panelNode.hasClass('accepted')) {
        panelNode.addClass('accepted');
        window.viewer.addCheckmarkById(uuid);
      } else {
        panelNode.removeClass('accepted');
        window.viewer.removeCheckmarkById(uuid);
      }
    }
  }

  navigateNext(doneProgress) {
    const navigationNext = $('.navigation-arrow--right');
    if (doneProgress === 1 || navigationNext.length === 0) {
      this.panel.hide();
    } else {
      navigationNext.click();
    }
  }
}

ContentManager.Content = {
  Chunk: 0,
  Behavior: 1,
  Node: 2,
  Task: 3,
  Quiz: 4,
  Blog: 5,
  BlogPost: 6,
  Legend: 7,
  Correlation: 8,
  Circle: 9,
  Evaluation: 10,
};
